import { DS_setData } from '../DS/DS.Data'
import { IDB_slugs } from '../IDB/IDB.dexie'
import { IDB_languageOverridesReadAll } from '../IDB/IDB.table.languageOverride'

export async function I18N_initialise() {
    // Read the slugs and language overrides from the disk
    const [slugs, languageOverrides] = await Promise.all([IDB_slugs().get(), IDB_languageOverridesReadAll()])

    // Put it into memory
    DS_setData('LanguageInitialized', () => ({
        slugs,
        languageOverrides,
    }))
}
